import urlPrefix from "./apiPrefix";

export const getEntrepreneurshipObjectList = () => `${urlPrefix.value}/tax-web-control/api/entrepreneurship-object/list`;
